export class FileControl {
  Id: string;
  File: any;
  FileName: string;
  Key?: string;
  Module?: number;
  Position?: number;
  Check?: boolean;
}
